import SectionHeading from "@/components/base/SectionHeading";
import { timeline } from "@/mocks/timeline";

export default function TimelineSection() {
  return (
    <section id="timeline" className="scroll-mt-24 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-content px-4 md:px-6">
        <SectionHeading
          kicker="Timeline"
          title="吃瓜时间线"
          description="按时间顺序把本季被反复讨论的现场串起来，方便一次补完前因后果，而不是只看到十几秒的断章。"
        />

        <ol className="relative mt-10 border-l border-background-300 pl-6 md:pl-8">
          {timeline.map((item, index) => (
            <li key={item.date} className="relative pb-9 last:pb-0">
              <span
                className={`absolute -left-[31px] top-1 flex h-4 w-4 items-center justify-center rounded-full border-2 md:-left-[39px] ${
                  index === 0
                    ? "border-accent-500 bg-accent-500"
                    : "border-background-400 bg-background-50"
                }`}
              />
              <div className="flex flex-wrap items-center gap-3">
                <time className="font-heading text-sm font-bold text-primary-700">
                  {item.date}
                </time>
                <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs text-secondary-900">
                  {item.tag}
                </span>
              </div>
              <h3 className="mt-2 font-heading text-base font-semibold text-foreground-950 md:text-lg">
                {item.title}
              </h3>
              <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">
                {item.text}
              </p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}